module.exports = __webpack_public_path__ + "static/media/aksa-studio.90728045.mp4";